// Central theme file for fonts and colors

export const FONT_FAMILY = 'Arial, sans-serif';

export const PURPLE = '#a259ff';

export const LIGHT_PURPLE = '#f3e9ff';

export const COLORS = {
  background: 'rgba(20, 20, 30, 0.95)',
  text: '#fff',
  accent: '#b0d0ff',
  boxBackground: 'rgba(30, 30, 40, 0.92)',
  leftPane: 'rgba(24, 24, 40, 1)',
  topRightPane: 'rgba(34, 34, 34, 1)',
  bottomRightPane: 'rgba(51, 51, 51, 1)',
  boxShadow: '0 2px 8px rgba(0,0,0,0.18)',
  focusBorder: PURPLE,
  lightPurple: LIGHT_PURPLE,
}; 